import React from "react";
import "./shows.css";

export default function Shows() {
  return (
    <div className="page shows-page">
      <section className="panel shows-panel">
        <h1>Shows</h1>
        <h2 className="shows-muted">Come see us live!</h2>
        <div className="shows-list">
          <h3><b>Last Night:</b> Your Mom's House</h3>
          <p>City, STATE</p>
        </div>
      </section>
    </div>
  );
}